var path = 'src/app/patients/rituximab/criteria.html';
var html = "<h1 class=page-header>Selection Criteria</h1> <div rituximab-criteria-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/rituximab/criteria.html
 ** module id = 591
 ** module chunks = 0
 **/